module.exports = __webpack_public_path__ + "static/media/rotateRight.5073ec1c.svg";